'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
const StyledWrapper = styled.span.withConfig({
  displayName: "Price__StyledWrapper",
  componentId: "sc-860263-0"
})(["font-weight:", ";"], WEB_FONT_DEMI_BOLD_WEIGHT);

const Price = ({
  children,
  value
}) => {
  return /*#__PURE__*/_jsx(StyledWrapper, {
    children: value == null ? children : /*#__PURE__*/_jsx(FormattedCurrency, {
      currencyCode: "USD",
      simplifyCurrency: true,
      value: value
    })
  });
};

Price.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number
};
export default Price;